import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
// import Benefits from '../components/Benefits';
import Instructor from '../components/Instructor';
import Program from '../components/Program';
import FAQ from '../components/FAQ';
import InstructorDrawer from '../components/InstructorDrawer';
import Footer from '../components/Footer';
import Mission from '../components/Mission';
import Instagram from '../components/Instagram';


function HomePage() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Mission />
    <Program />
      {/* <Benefits /> */}
      <Instructor onOpenDrawer={() => setDrawerOpen(true)} />
      <FAQ />
      <Instagram />
      <Footer />
      <InstructorDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </div>
  );
}

export default HomePage;
